import { InputHTMLAttributes, forwardRef } from 'react';

import styles from './TableInput.module.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    error?: string
    bgcolor?: string
    bottombordercolor?: string
    svg?: React.ReactElement
}

export const TableInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const attrs = {...props};

    const classes = [
        styles['table-input-container'],
        props.error ? styles.error : ''
    ].join(' ')

    return (
        <div 
            className={classes}
            style={{ "--bg-color": props.bgcolor } as React.CSSProperties}
        >
            <input ref={ref} {...attrs}/>
            <hr
                style={{ "--bottom-border-color": props.bottombordercolor } as React.CSSProperties}
            />
            {props.svg? props.svg : <></>}
        </div>
    );
});

TableInput.displayName = 'TableInput';
